<template>
    <div id="AssetSale">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Asset Sale List</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                                <i class="fp-export"></i> Export
                            </a>
                            <router-link class="btn btn-primary" v-bind:to="{name: 'AssetSaleCreate',params:{flag:'fromList'}}" >
                                <i class="fp-add"></i>    Add
                            </router-link>
                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-sale-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'AssetSaleList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'AssetSaleList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listAssetSale"
                                      mode="remote"
                                      title="Asset Sale"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-select-all="onSelectAll"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: true,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      >
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="props.row.posted == 'No'">
                                                      <router-link title="Update Schedule" class="fp-edit" v-bind:to="{name: 'AssetSaleEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                                  <router-link title="View Schedule" class="fp-view ml-2" v-bind:to="{name: 'AssetSaleView',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-else>
                                                  <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button v-if="assetSalePost" id="post_sale" class="btn btn-primary" v-on:click="postSalesBill('post')"> <i class="fp-calendar"> </i> Post </button>
                                          <button v-if="assetSalePost" id="post_invoice" class="btn btn-primary" v-on:click="postSalesBill('invoice')"> <i class="fp-calendar"> </i> Generate Invoice </button>
                                          <!-- <button v-if="assetSaleReverse" id="reverse" class="btn btn-primary" v-on:click="reverseBill()"> <i class="fp-reverse"> </i> Reverse </button> -->
                                          <!-- <div class="form-row"> -->
                                            <!-- <div class="pull-right offset-md-2"> -->
                                                <div class="dropdown pull-right custom-margin">
                                                     <label class="btn btn-primary pull-left" style="border-top-right-radius: 0;border-bottom-right-radius: 0;">
                                                        Reverse
                                                    </label>
                                                    <button class="btn btn-primary dropdown-toggle pull-left" id="dropdownMenuButton" data-toggle="dropdown" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><span class="caret"></span></button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <!-- <li><a href="javascript:void(0)" v-on:click="performAction('store_private')">Store Private</a></li> -->
                                                        <a class="dropdown-item btn btn-primary" href="javascript:void(0)" v-on:click="reverseBill('posted')">Posted Reverse</a>
                                                        <!-- <a class="dropdown-item" href="javascript:void(0)" v-on:click="performAction('set_as_default')">Set As Default</a> -->
                                                        <a class="dropdown-item btn btn-primary custom-margin-top" href="javascript:void(0)" v-on:click="reverseBill('invoice')">Invoice Reverse</a>
                                                    </div>
                                                </div>
                                            <!-- </div> -->
                                        <!-- </div> -->
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import moment from 'moment';


    export default {
        name: "AssetSaleList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Asset Sale List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Unit',
                    field: 'unit_no',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Make',
                    field: 'make',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Make", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'model',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Year',
                    field: 'year',
                    fpFieldType:"text",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Available For Sale/Added To Sales List',
                    field: 'available_for_sale',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Available For Sale", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Net Book Value',
                    field: 'net_book_value',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Net Book Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Resale Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Duration", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Invoice Number',
                    field: 'inv_number',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Invoice Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Posted',
                    field: 'posted',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Posted", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },{
                    label: "VIN",
                    field: "vin_no",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                    enabled: false,
                    placeholder: "VIN No.",
                    filterValue: "",
                    trigger: "enter"
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 10
            },
            loading:false,
            selectedFile:"",
            error:"",
            pageKey:"_vehicle_sale_list_",
            action:'list',
            effective_date:'',
            vehicle_pool_id:'',
            location_id:'',
            locationArr:[],
            vehiclepoolArr:[],
            effective_date_error_msg:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            dateArr:[],
            assetSalePost:false,
            assetSaleReverse:false,
            batchProcess:0,
            batchNum:"",
            requestInProgress: false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_sales') {
                            self.cantAccessPage = true;
                        } else if ( permissions[i].name == 'reverse_asset_sale' ) {
                            self.assetSaleReverse = true;
                        } else if ( permissions[i].name == 'post_asset_sale' ) {
                            self.assetSalePost = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },

        mounted: function() {
            var self = this;
            //self.loadList();

            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();
            // this.loadFieldData(['depriciation_type']);

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetSale.unselectAllInternal();
            },
            exportCheck: function() {
              var count = 0;
              var actionFlag = "";
              var data = this.$refs['listAssetSale'].selectedRows;
              count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
              this.exportReports(actionFlag);
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                 var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listAssetSale'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listAssetSale'].selectedRows[i].id)
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    selectedRows:selectedRows,
                    selectedAll:self.serverParams.selectedAll
                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/asset-sale/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {
                                  if ( self.action == "export" ) {
                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }
                              }
                              self.action = "list";
                              self.loadList();

                            } else {

                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-inventory-list')

                    }
                });
            },
            reverseBill:function(flag){
                var self = this;
                var data = this.$refs['listAssetSale'].selectedRows;
                var selectedRows = [];
                for ( var i = 0; i < data.length; i++ ) {
                    if (data[i].posted == 'no'){
                        self.$swal('','Only posted bill can be reverse','info');
                        return;
                    }
                    if (flag == 'invoice'){
                        if (data[i].inv_number == null || data[i].inv_number == ''){
                            self.$swal('','Please select the records with invoice to reverse the invoice','info');
                            return;
                        }
                    }
                    selectedRows.push(this.$refs['listAssetSale'].selectedRows[i].id)
                }

                if (confirm('All the disposal will be reversed which are posted together, Are you sure ?')){

                    var fields = {
                        selectedRows:selectedRows,
                        flag:flag
                    };

                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/asset-sale/reverse",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            // console.log(data);
                            if (data.status == "success") {
                                self.$swal('',data.message,'success');
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'asset-inventory-list')

                        }
                    });
                }



            },
            postSalesBill:function(flag) {
                var self = this;
                var selectedRows = [];

                var data = this.$refs['listAssetSale'].selectedRows;
                // for ( var i = 0; i < data.length; i++ ) {
                //     selectedRows.push(this.$refs['listAssetSale'].selectedRows[i].id)
                // }

                // if (data.length > 1){
                //     self.$swal('','Asset Sale can be posted one at a time','info');
                //     return;
                // }else{
                var custIdArr = [];
                if (flag == 'invoice'){
                    for ( var i = 0; i < data.length; i++ ) {
                        if (data[i].posted && data[i].posted.toLowerCase() == 'no'){
                            self.$swal('','Please select only posted sale','info');
                            return;
                        }
                        if (data[i].posted && data[i].inv_number != null && data[i].posted && data[i].inv_number != '' ){
                            self.$swal('','Invoice is already generated for some sale record','info');
                            return;
                        }
                        if (data[i].customer_id && data[i].customer_id != null){
                            if (custIdArr.length > 0 && $.inArray(data[i].customer_id, custIdArr) == -1){
                                self.$swal('','Please select records with same customer','info');
                                return;
                            }
                            custIdArr.push(data[i].customer_id);
                        }
                        selectedRows.push(data[i].id)
                    }
                    if (selectedRows.length > 0){
                        self.generateSaleInvoice(selectedRows);
                    }
                }else{
                    for ( var i = 0; i < data.length; i++ ) {
                        if (data[i].posted && data[i].posted.toLowerCase() == 'yes'){
                            self.$swal('','Asset Bill Already Posted','info');
                            return;
                        }
                        // if (data[i].posted && data[i].posted.toLowerCase() == 'yes'){
                        //     self.$swal('','Asset Bill Already Posted','info');
                        //     return;
                        // }
                        selectedRows.push(data[i].id)
                    }

                    self.storeSaleBatch(selectedRows);
                }

                    // self.$router.push('/bill-sale/create/'+data[0].id);

                // }
            },

            generateSaleInvoice:function(idArr){
                var self = this;
                if(self.requestInProgress == true){
                  return;
                }
                self.requestInProgress = true;
                self.loading = true;
                $.ajax({
                url: process.env.ROOT_API + "/generate-sale-invoice",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    sale_id:idArr,
                    from:'multiple'
                },
                success: function (data) {
                    self.loading = false;
                    self.requestInProgress = false;
                    if (data.status == "success") {
                       self.$router.push("/invoice/asset-sale/view/"+data.content+'?saleId='+idArr[0]+'&from=asset-sale-list');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.requestInProgress = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-sale-invoice')

                }
            });
            },

            storeSaleBatch:function(idArr){
                var self = this;
                if(self.requestInProgress == true){
                  return;
                }
                self.requestInProgress = true;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/sale-batch/store",
                    type: "POST",
                    data: {
                        ids:idArr
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.requestInProgress = false;
                        if (data.status == "success") {
                            self.$router.push('/bill-sale/create/'+data.content.id+'?batch='+data.content.batch);
                        }else{
                            self.$swal('','Asset Bill Already Posted','info');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.requestInProgress = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-sale-list')

                    }
                });
            }
        },

    };
</script>
<style scoped>
.custom-margin{
    margin-left:5px !important;
}
.custom-margin-top{
    margin-top:5px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/asset/AssetSaleList.vue